module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ko_kyushu-ed832931099bc9e94f0aac100a0d91b3.jpg";